import { Component, OnInit } from '@angular/core';
import { UtilService, DialogService, NotificationService, TranslationService } from '../../../shared/index';
import { NavigationService } from '../../../shared/navigation/navigation.service';
import { CardConnectService } from '../shared/card-connect.service';
import { FundingResponse } from '../shared/funding-response.model';
import { CreditCardGateway } from '../../../revenue/shared/credit-card-gateway/credit-card-gateway.model';
import { CreditCardGatewayService } from '../../../revenue/shared/credit-card-gateway/credit-card-gateway.service';
import { TransDetail } from '../shared/trans-detail.model';

@Component({
  selector: 'wl-card-connect-trans',
  templateUrl: 'card-connect-trans.component.html',
  providers: [CardConnectService, CreditCardGatewayService],
    standalone: false
})
export class CardConnectTransComponent implements OnInit {
  public _utilService: UtilService;
  public _notifyService: NotificationService;
  public _translationService: TranslationService;
  public _cardConnectService: CardConnectService;
  public _dialogService: DialogService;
  public _creditCardGatewayService: CreditCardGatewayService;
  public _navigationService: NavigationService;

  public isSearching: boolean;
  public fundingTransactionsResponse: FundingResponse;
  public startDate: Date;
  public endDate: Date;
  public cardConnectGateways: Array<CreditCardGateway>;
  public selectedGatewayId: number;
  public showModal = false;
  public selectedTransaction: TransDetail;

  public constructor(
    utilService: UtilService,
    notifyService: NotificationService,
    translationService: TranslationService,
    cardConnectService: CardConnectService,
    dialogService: DialogService,
    creditCardGatewayService: CreditCardGatewayService,
    navigationService: NavigationService
  ) {
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translationService = translationService;
    this._cardConnectService = cardConnectService;
    this._dialogService = dialogService;
    this._creditCardGatewayService = creditCardGatewayService;
    this._navigationService = navigationService;

    this.fundingTransactionsResponse = new FundingResponse();
    this.isSearching = false;
    this.startDate = new Date();
    this.endDate = new Date();
    this.cardConnectGateways = new Array<CreditCardGateway>();
    this.selectedGatewayId = 0;
    this.selectedTransaction = new TransDetail();
  }

  public ngOnInit() {
    this._creditCardGatewayService.getCardConnectCreditCardGateways().then((data: Array<CreditCardGateway>) => {
      this.cardConnectGateways = data;
      if (data.length > 0) {
        this.selectedGatewayId = data[0].CCGatewayID;
      }
    });
  }

  public searchFundingTransactions = (): void => {
    this.isSearching = true;
    this._cardConnectService.getFundingTransactions(this.selectedGatewayId, this.startDate, this.endDate).then((data: FundingResponse) => {
      this.fundingTransactionsResponse = data;
      this.isSearching = false;
    });
  };

  public processCreditCard = (): void => {
    this._navigationService.navigate('/revenue/epayment/creditcard/charge');
  };

  public getTransactionDetail = (retref: string): void => {
    this._cardConnectService.getTransactionDetail(this.selectedGatewayId, retref).then((data: TransDetail) => {
      this.selectedTransaction = data;
      this.showModal = true;
    });
  };

  public selectInvoice = (invoiceNumber: number): void => {
    this._navigationService.navigateToInvoiceReport(invoiceNumber);
  };

  public onGatewayChange(data: string) {
    //the data comes thru as a string convert to int
    this.selectedGatewayId = parseInt(data);
  }
}
